import type { JSX } from "react";
import { Link } from "react-router-dom";
import { Button, EmptyState } from "@mailflare/ui";

import { routes } from "@/features/mailboxes/routes";

export function NotFoundPage(): JSX.Element {
  return (
    <EmptyState
      title="Page not found"
      description="The page you were looking for does not exist."
      action={
        <Button asChild variant="outline">
          <Link to={routes.root}>Back to mail</Link>
        </Button>
      }
      className="m-auto"
    />
  );
}
